<template>
  <div>
    <div class="page-header header-filter bg-3">
      <b-container>
        <b-row>
          <b-col>
            <h1 class="centre"><b>RIDE:</b> {{ this.ride.title }}</h1>
            <h2 class="centre">{{ playerName }} @ {{ rideCreated }}</h2>
          </b-col>
        </b-row>

        <b-row align-h="center" style="margin-top:40px;margin-bottom:20px">
          <b-col cols="8" sm="5">
            <stat-field :stat="starGain" sub="JAX" size="lg"/>
          </b-col>
        </b-row>

        <b-row align-v="stretch">
          <b-col cols="12" md="4">
            <b-card
              bg-variant="info"
              footer="Duration"
              class="text-center">
              <b-card-text>
                <h3>{{ rideDuration }}</h3>
              </b-card-text>
            </b-card>
          </b-col>
          <b-col cols="12" md="4">
            <b-card
              bg-variant="danger"
              footer="Calories Burned"
              class="text-center">
              <b-card-text>
                <h3>{{ calories }}</h3>
              </b-card-text>
            </b-card>
          </b-col>
          <!-- <b-col cols="6" sm="3">
            <b-card
              bg-variant="primary"
              footer="KM"
              class="text-center">
              <b-card-text>
                <h3>{{ kilometers }}</h3>
              </b-card-text>
            </b-card>
          </b-col> -->
          <b-col cols="12" md="4">
            <b-card
              bg-variant="dark"
              footer="Missions"
              class="text-center">
              <b-card-text>
                <h3>{{ efforts.length }}</h3>
              </b-card-text>
            </b-card>
          </b-col>
        </b-row>
      </b-container>
    </div>

    <div>
      <b-container>
        <b-row style="margin: 32px 0">
          <b-col>
            <h1 class="centre">Mission Attempts</h1>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-table-lite
              striped
              responsive
              borderless
              hover
              tbody-tr-class="table-row"
              :items="efforts"
              :fields="effortFields"
              @row-clicked="onEffortRowClicked"
            >
            </b-table-lite>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import { BCard, BCardText, BTableLite } from "bootstrap-vue";
import utils from "../utils";
import StatField from '../components/StatField.vue';

const { mapState, mapActions } = createNamespacedHelpers("rideDetails");

export default {
  name: "RideDetails",
  props: ["id"],
  components: { BCard, BCardText, BTableLite, StatField },
  async created() {
    await this.loadRideDetails(this.id);
  },
  computed: {
    ...mapState({
      ride: "ride",
    }),
    rideCreated() {
      return utils.strToDateLocale(this.ride.createdAt);
    },
    playerName() {
      return this.ride.player && this.ride.player.name;
    },
    kilometers() {
      return (this.ride.kilometers && this.ride.kilometers.toFixed(2)) || "--";
    },
    calories() {
      return (this.ride.wattHours && utils.whToCal(this.ride.wattHours).toFixed(0)) || "--";
    },
    rideDuration() {
      return (
        (this.ride.duration &&
          utils.durationStrFromSecs(this.ride.duration)) ||
        "--"
      );
    },
    efforts() {
      return this.ride.questEfforts && this.ride.questEfforts.items || [];
    },
    starGain() {
      return (this.efforts.length > 0) ? this.efforts.map(v => v.starGain).reduce((p, c) => p + c) : 0;
    }
  },
  methods: {
    ...mapActions(["loadRideDetails", "clearStoreState"]),
    onEffortRowClicked(item, index) {
      console.log(`Effort clicked: ${JSON.stringify(item)}. Index: ${index}.`);
      this.$router.push({ name: "quest", params: { id: item.questId } });
    },
  },
  data() {
    return {
      effortFields: [
        { key: "quest.title", label: "Mission", formatter: (v, k, i) => 
          `${v} (${(i.quest.type == 'TimeTrial') ? 'TT' : 'CR'})`
        },
        { key: "createdAt", label: "Started", formatter: utils.strToTimeLocale },
        { key: "score", label: "Result", formatter: (v, k, i) => utils.formatScore(v, i.quest.type) },
        { key: "starGain", label: "JAX", formatter: (v, k, i) => `+${v} (PB:${i.starRating})` },
      ],
    };
  },
  destroyed() {
    this.clearStoreState();
  },
};
</script>

<style scoped>
.page-header {
  height: auto;
  padding-top: 100px;
  padding-bottom: 50px;
}
</style>